import React from "react";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Cell, Tooltip as RTooltip,
} from "recharts";

export const RiskDistributionChart = ({ stats }) => {
  const chartData = [
    { name: "Low", value: stats.low, color: "#2f9e6b" },
    { name: "Medium", value: stats.medium, color: "#c98a0c" },
    { name: "High", value: stats.high, color: "#c93838" },
  ];
  return (
    <div className="rounded-xl border bg-card p-5 lg:col-span-1">
      <h3 className="font-display text-base font-semibold">Risk distribution</h3>
      <p className="text-xs text-muted-foreground">All-time bookings by risk band</p>
      <div className="mt-4 h-52">
        {stats.total_all_time === 0 ? (
          <div className="flex h-full items-center justify-center text-sm text-muted-foreground">No data yet</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
              <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={12} />
              <YAxis allowDecimals={false} tickLine={false} axisLine={false} fontSize={12} />
              <RTooltip cursor={{ fill: "hsl(var(--accent))" }} contentStyle={{ borderRadius: 12, border: "1px solid hsl(var(--border))", fontSize: 13 }} />
              <Bar dataKey="value" radius={[6, 6, 0, 0]} maxBarSize={56}>
                {chartData.map((d) => <Cell key={d.name} fill={d.color} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
      <div className="mt-3 flex items-center justify-around text-xs">
        <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-[#2f9e6b]" />Low {stats.low}</span>
        <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-[#c98a0c]" />Med {stats.medium}</span>
        <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-[#c93838]" />High {stats.high}</span>
      </div>
    </div>
  );
};
